<template>
    <div>
        <template>
            <b-card header-tag="header" footer-tag="footer" class="mt-8">
            <template v-slot:header>
                <p class="mb-0 text-center" style="font-size: 21px">Detalle del cliente:<b> {{clienteInfo.cliente}} </b></p>
            </template>
            <b-card-text>
                <div><b>Fecha Registro:</b> {{clienteInfo.created_at}} </div>
                <div><b>Documento:</b> {{clienteInfo.documento}} </div>
                <div><b>Correo:</b> {{clienteInfo.correo}} </div>
                <div><b>Telefono:</b> {{clienteInfo.telefono}} </div>
                <div><b>Departamento:</b> {{clienteInfo.departamento}}</div>
                <div><b>Ciudad:</b> {{clienteInfo.ciudad}} </div>
                <div><b>Dirección:</b> {{clienteInfo.direccion}} </div>
            </b-card-text>
            <b-card-text bg-variant="secondary">
                <p class="mb-0 text-center" style="font-size: 21px">Pedidos Realizados:</p>
            </b-card-text>
            <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover 
                :items="pedidos">
                <template v-slot:cell(id)="data">
                    {{ data.item.id }}
                </template>
                <template v-slot:cell(nombre_usuario)="data">
                    {{ data.item.nombre_usuario }}
                </template>
                <template v-slot:cell(created_at)="data">
                    {{ data.item.created_at }}
                </template>
                <template v-slot:cell(total_precio)="data">
                    $ {{numberFormat(data.item.total_precio) }}
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button size="sm" variant="info" v-b-tooltip.hover title="Ver" class="text-white" 
                    :to="{name: 'InfoPedido', params:{ id: item.id}}">
                        <b-icon icon="search"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="getOrderSize">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
            <template v-slot:footer>
                <b-button id="volver" variant="danger" 
                    class="text-white mr-2" 
                    :to="{name: 'ListadoClientes'}">
                    Volver Listado
                </b-button>
            </template>
        </b-card>
        </template>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
    computed: {
        ...mapState('configuration', ['tipoDocumentoCliente']),
         getOrderSize() {
            return this.pedidos < 1 ? true : false;
        }
    },
    data(){
        return{
            clienteInfo: {},
            errors: {},
            errores: false,
            fields: [
                { key: 'id', label: '#', sortable: true},
                { key: 'nombre_usuario', label: 'Realizado Por', sortable: true},
                { key: 'created_at', label: 'Fecha', sortable: true},
                { key: 'total_precio', label: 'Precio Total', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
            pedidos: [],
        }
    },
    created(){
        this.getClienteInfo();
    },
    methods: {
        ...mapMutations(['setLoading']),
        back(){
            this.$router.go(-1);
        },
        async getClienteInfo(){
            try {
                this.setLoading(true);
                const response = await this.$conectar.post('/clientes/get-client-and-order-info', {
                    id: this.$route.params.id
                });
                this.clienteInfo = response.data.clienteInfo;
                this.pedidos = response.data.clienteInfo.pedidos;
            } catch (e) {
                console.log(e);
            } finally {
                this.setLoading(false);
            }
        },
     
    }
    
}
</script>